export default "__VITE_ASSET__a92fbb7a__"